module.exports = __webpack_public_path__ + "static/story_img1@2x-ebeaddf7bce9051fd7f5e5f8f0770006.jpg";